/**
 * Tamanho médio dos blocos, medido: por produto e nível, a partir dos bytes
 * que chegam (cache.ts). O teto de download do motor (`BYTES_MAX`) e a
 * estimativa do que falta baixar usam esta média — os blocos variam de ~40 KB
 * (noite, banda limpa) a ~340 KB (dia, banda 02), e uma constante única
 * errava o teto por um fator de 2 ou mais.
 *
 * Média simples nos primeiros blocos e depois móvel (o dia vira noite).
 */
import { BYTES_POR_BLOCO, ehNivel, type Nivel } from './blocos';

const AMOSTRAS_MEDIA_SIMPLES = 20;
const PESO_NOVO = 0.05;

const medias = new Map<string, { n: number; media: number }>();
const chave = (produto: string, nivel: Nivel) => `${produto}@${nivel}`;

export function registrarTamanho(produto: string, nivel: Nivel, bytes: number): void {
  if (!(bytes > 0)) return;
  const k = chave(produto, nivel);
  const m = medias.get(k) ?? { n: 0, media: 0 };
  m.n++;
  m.media = m.n <= AMOSTRAS_MEDIA_SIMPLES ? m.media + (bytes - m.media) / m.n : m.media + (bytes - m.media) * PESO_NOVO;
  medias.set(k, m);
}

/** Bytes esperados por bloco desse produto e nível (medido, ou a estimativa inicial). */
export function bytesPorBloco(produto: string, nivel: Nivel): number {
  return medias.get(chave(produto, nivel))?.media ?? BYTES_POR_BLOCO;
}

/** Produto e nível de um endereço de bloco (".../nsa/<produto>/<carimbo>/<nível>/<l>_<c>.jpg"). */
export function blocoDaUrl(url: string): { produto: string; nivel: Nivel } | null {
  const m = /\/nsa\/([^/]+)\/\d{11}\/(\d+)\/\d+_\d+\.jpg$/.exec(url);
  const nivel = m ? Number(m[2]) : NaN;
  return m && ehNivel(nivel) ? { produto: m[1]!, nivel } : null;
}

/** (debug e testes) as médias atuais, e zerar. */
export const mediasDeTamanho = () => Object.fromEntries([...medias].map(([k, v]) => [k, Math.round(v.media)]));
export const zerarTamanhos = () => medias.clear();
